var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2124_1584)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.8254 13.8404C12.9916 13.5981 13.3498 13.5981 13.5159 13.8404L24.3164 29.5909C24.5064 29.8679 24.3076 30.2441 23.9711 30.2441H2.37024C2.03381 30.2441 1.83499 29.8679 2.02498 29.5908L12.8254 13.8404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7766 13.8404C14.9427 13.5981 15.301 13.5981 15.4671 13.8404L26.2676 29.5909C26.4575 29.8679 26.2587 30.2441 25.9223 30.2441H4.32141C3.98498 30.2441 3.78617 29.8679 3.97615 29.5908L14.7766 13.8404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.1711 14.1466C33.1711 16.0324 31.6423 17.5612 29.7564 17.5612C27.8706 17.5612 26.3418 16.0324 26.3418 14.1466C26.3418 12.2607 27.8706 10.7319 29.7564 10.7319C31.6423 10.7319 33.1711 12.2607 33.1711 14.1466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.5376 19.689C24.7018 19.4533 25.0535 19.4533 25.2176 19.689L32.121 29.6027C32.3099 29.874 32.1138 30.2439 31.781 30.2439H17.9743C17.6414 30.2439 17.4453 29.874 17.6343 29.6027L24.5376 19.689Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4888 19.689C26.653 19.4533 27.0046 19.4533 27.1688 19.689L34.0721 29.6027C34.2611 29.874 34.065 30.2439 33.7322 30.2439H19.9254C19.5926 30.2439 19.3965 29.874 19.5854 29.6027L26.4888 19.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1457 13.1705C34.1457 15.0563 32.6169 16.5851 30.731 16.5851C28.8452 16.5851 27.3164 15.0563 27.3164 13.1705C27.3164 11.2846 28.8452 9.75586 30.731 9.75586C32.6169 9.75586 34.1457 11.2846 34.1457 13.1705Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2124_1584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.41415a4f9f2910f4a1dba82d505cfd13.svg";
export { ForwardRef as ReactComponent };